// extracted by mini-css-extract-plugin
export default {"image":"InfoButton_image__sDGc8"};